import React, { useContext, useEffect, useRef } from "react";
import dayjs from "dayjs";
import OccupantView from "../components/OccupantView";
import DriverVehicleView from "../components/DriverVehicleView";
import AdForm from "../components/AdForm";
import AppContext from "../context";
import WeatherIcon from "../components/WeatherIcon";
import { useTranslation } from "react-i18next";
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

export default function AccidentMobile({ a }) {
	const lc = (text) => {
		if (text) return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
		return "";
	};
	const { setModal } = useContext(AppContext);
	const safetyCards = useRef();
	const driverCards = useRef();
	const vehicleCards = useRef();
	const { t } = useTranslation();

	useEffect(() => {
		document.getElementsByTagName("body")[0].id = "ACCIDENT";
	}, []);

	return (
		<div id="mobile-accident">
			<div className="container" id="accident-top">
				<a onClick={() => toggleMenu()}>
					<img src="/assets/icon-menu.svg" className="menu" />
				</a>
				<a href="/">
					<img src="/assets/logo.png" className="logo" />
				</a>
			</div>

			<div className="top-bar">
				<span>
					<strong>{t("CASE_ID")}: </strong>
					{a.caseID}
				</span>
				<button onClick={() => setModal("download")}>
					<img src="/assets/icon-download.svg" />
				</button>
				<span>
					<strong>{t("CRASH_ID")}: </strong>
					{a.crash_id}
				</span>
			</div>

			<div className="occupant-form-holder">
				<div className="inner">
					{a.vehicles.map((v, k) => (
						<div className="occupant-holder" key={k}>
							<div className="head">
								{lc(v.vehicle_maker)}
								<span>
									{v.vehicle_model_year ? "" + v.vehicle_model_year : ""}
									{v.vehicle_color ? " " + lc(v.vehicle_color) : ""}
								</span>
							</div>
							<OccupantView v={v} key={v._id} k={k} />
						</div>
					))}
				</div>
			</div>

			<div className="top-bar">
				<span>
					<strong>{t("LOCATION")}: </strong>
					<br />
					{a.city && a.state ? a.city + ", " + a.state : a.location_address}
				</span>
				<span>
					<strong>{t("DATE___TIME")}: </strong>
					<br />
					{dayjs(a.date).format("MM/DD/YY hh:mm A")}
				</span>
			</div>

			<div style={{ position: "relative" }}>
				<img
					src={`https://maps.googleapis.com/maps/api/staticmap?center=${a.location_lat},${a.location_lng}&style=visibility:on&zoom=15&scale=1&size=640x480&maptype=roadmap&key=AIzaSyCb4X58O574pZiBot_hf3N9q_bGu9yO8i8&format=png&visual_refresh=true&markers=icon:https://myaccident.org/images/location-pin-01.webp%7Cshadow:false%7C${a.location_lat},${a.location_lng}`}
					width="100%"
					height="100%"
					style={{ objectFit: "cover", minHeight: 300 }}
				/>
				{/* <div
							style={{
								width: "100%",
								height: "100%",
								background: "#CCC",
								minHeight: 300
							}}
						/> */}
				<div id="conditions">
					<div>
						<img src="/assets/icon-road.svg" alt="Weather and Traffic icon" />
						<div>
							<strong>{t("ROAD___TRAFFIC_CONDITIONS")}</strong>
							{a.traffic_conditions}
						</div>
					</div>
					<div>
						<WeatherIcon a={a} />
						<div>
							<strong>{t("WEATHER")}</strong>
							{a.weather_conditions}
						</div>
					</div>
				</div>
			</div>

			<section>
				<img src="/assets/icon-description.svg" />
				<div>
					<strong>{t("DESCRIPTION")}</strong>
					{a.description}
					{a.summary}
					{a.narrative ? (
						<div>
							<br />
							<strong>{t("ADDITIONAL_NARRATIVE")}</strong>
							{a.narrative}
						</div>
					) : null}
				</div>
			</section>

			<section>
				<img src="/assets/icon-car.svg" />
				<div>
					<strong>{t("ACCIDENT_CONTRIBUTING_FACTORS")}</strong>
					{a.accident_contributing_factors}
				</div>
			</section>

			<section>
				<img src="/assets/icon-date-time.svg" />
				<div>
					<strong>{t("DATE___TIME_OF_CRASH")}</strong>
					{dayjs(a.date).format("MM/DD/YY hh:mm A")}
				</div>
			</section>
			<section>
				<img src="/assets/icon-speed-limit.svg" />
				<div>
					<strong>{t("SPEED_LIMIT")}</strong>
					{a.crash_speed_limit && a.crash_speed_limit !== -1
						? `${a.crash_speed_limit} MPH`
						: "unknown"}
				</div>
			</section>
			<section>
				<img src="/assets/icon-pd.svg" />
				<div>
					<strong>{lc(a.agency)}</strong>
					{a.agency_phone}
				</div>
			</section>
			<section className="aligned triangle">
				<img src="/assets/num.svg" />
				<span className="triangle-number">{a.total_injury_count}</span>
				<strong>{t("TOTAL_NUMBER_OF_INJURIES")}</strong>
			</section>

			<section className="aligned">
				<span className="circle">{a.vehicles.length}</span>
				<strong>{t("TOTAL_NUMBER_OF_VEHICLES")}</strong>
			</section>

			<section className="aligned">
				<span className="circle">
					{a.non_injury_count + a.total_injury_count || a.people_count}
				</span>
				<strong>{t("TOTAL_NUMBER_OF_OCCUPANTS")}</strong>
			</section>
			<section>
				<img src="/assets/icon-location.svg" />
				<div>
					<strong>{t("ACCIDENT_LOCATION")}</strong>
					{a.location_address}
				</div>
			</section>

			<div className="top-bar header">
				<strong>{t("SAFETY_INFORMATION")}</strong>
			</div>
			<div className="card-arrows">
				<a
					className="left"
					onClick={() =>
						safetyCards.current.scrollBy({
							left: -(window.innerWidth - 20),
							behavior: "smooth"
						})
					}
				>
					<img src="/assets/icon-arrow.svg" width="16" />
				</a>
				<a
					className="right"
					onClick={() =>
						safetyCards.current.scrollBy({
							left: window.innerWidth - 20,
							behavior: "smooth"
						})
					}
				>
					<img src="/assets/icon-arrow.svg" width="16" />
				</a>
			</div>

			<div className="mobile-cards safety" ref={safetyCards}>
				<div className="cards-inner">
					{a.vehicles.map((v, k) => (
						<div className="card" key={k}>
							<OccupantView v={v} key={v._id} k={k} />
						</div>
					))}
				</div>
			</div>

			<div className="top-bar header">
				<strong>{t("DRIVER_INFORMATION")}</strong>
			</div>

			<div className="card-arrows">
				<a
					className="left"
					onClick={() =>
						driverCards.current.scrollBy({
							left: -(window.innerWidth - 20),
							behavior: "smooth"
						})
					}
				>
					<img src="/assets/icon-arrow.svg" width="16" />
				</a>
				<a
					className="right"
					onClick={() =>
						driverCards.current.scrollBy({
							left: window.innerWidth - 20,
							behavior: "smooth"
						})
					}
				>
					<img src="/assets/icon-arrow.svg" width="16" />
				</a>
			</div>

			<div className="mobile-cards driver-info" ref={driverCards}>
				<div className="cards-inner">
					{a.vehicles.map((v, k) => (
						<div className="card" key={k}>
							<DriverVehicleView v={v} key={v._id} k={k} />
						</div>
					))}
				</div>
			</div>

			<div className="top-bar header">
				<strong>{t("VEHICLE_INFORMATION")}</strong>
			</div>

			<div className="card-arrows">
				<a
					className="left"
					onClick={() =>
						vehicleCards.current.scrollBy({
							left: -(window.innerWidth - 20),
							behavior: "smooth"
						})
					}
				>
					<img src="/assets/icon-arrow.svg" width="16" />
				</a>
				<a
					className="right"
					onClick={() =>
						vehicleCards.current.scrollBy({
							left: window.innerWidth - 20,
							behavior: "smooth"
						})
					}
				>
					<img src="/assets/icon-arrow.svg" width="16" />
				</a>
			</div>

			<div className="mobile-cards vehicle-info" ref={vehicleCards}>
				<div className="cards-inner">
					{a.vehicles.map((v, k) => (
						<div className="card" key={k}>
							<DriverVehicleView v={v} key={v._id} k={k} />
						</div>
					))}
				</div>
			</div>
			<br />
			<br />
			<AdForm a={a} />

			<button
				onClick={() => setModal("download")}
				className="floating-download"
			>
				{t("DOWNLOAD")}
			</button>
		</div>
	);
}
